import React from "react";
import { SectionHeading } from "../ui";
import { PageContainer } from "../layout/PageContainer";
import { RevealGroup, RevealItem, RevealStagger } from "../motion/Reveal";
import { PUBLIC_MOTION } from "../motion/publicMotion";

const benefits = [
  {
    title: "Shop för gruppens försäljning",
    description:
      "Kunden väljer produkter i shoppen och beställningen kopplas till rätt säljare och grupp.",
  },
  {
    title: "Varje säljare får egen länk och QR-kod",
    description:
      "Säljaren delar länken eller QR-koden med familj, vänner och andra som vill stötta gruppen.",
  },
  {
    title: "Två verifierade leveransvägar",
    description:
      "Beställningen kan skickas direkt till kunden eller samlas hos gruppen för gemensam utdelning.",
  },
];

export function BenefitsSection() {
  return (
    <section className="bg-white py-20">
      <PageContainer>
        <RevealGroup>
          <RevealItem tone="text">
            <SectionHeading
              eyebrow="Varför SalesPartner"
              title="Ett sammanhållet flöde för grupp, säljare och kund"
              description="Säljlänk, order och leverans hör ihop, samtidigt som gruppledaren behåller ansvaret för gruppens upplägg."
              align="center"
            />
          </RevealItem>
          <RevealStagger className="mt-12 grid gap-6 md:grid-cols-3" stagger={PUBLIC_MOTION.staggerCard}>
            {benefits.map((benefit) => (
              <RevealItem key={benefit.title} tone="card">
                <div className="rounded-3xl border border-slate-200 bg-slate-50 p-7 text-center shadow-sm transition duration-200 motion-safe:hover:-translate-y-0.5 motion-safe:hover:shadow-md">
                  <h3 className="text-xl font-semibold text-slate-900">{benefit.title}</h3>
                  <p className="mt-3 text-slate-600 text-sm leading-relaxed">{benefit.description}</p>
                </div>
              </RevealItem>
            ))}
          </RevealStagger>
        </RevealGroup>
      </PageContainer>
    </section>
  );
}
